import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/score/MScoreCategory/index",{
        params:params
    } )
}

function EXPORT(params) {
    return  axios.get("/statistics/Inquiry/inquiryRankingExport",{
        params: {
            ...params
        }
    }  )
}

function CHANG_STATUS(params) {
    return  axios.post("/score/MScoreCategory/statusEdit",{status:params} )

}
function ADD_DATA() {
    return  axios.get("/score/MScoreCategory/add",{
        params: {}
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/score/MScoreCategory/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/score/MScoreCategory/editPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/score/MScoreCategory/edit",{
        params: {
            ...params
        }
    } )
}

function DELE(params) {
    return  axios.get("/score/MScoreCategory/delete",{
        params: {
            ids:params
        }
    } )
}
function LIST_ORDER(params) {
    return  axios.post("/score/MScoreCategory/listOrder",{list_orders:params} )
}
export default {
    GET_LIST,
    EXPORT,
    CHANG_STATUS,
    ADD_DATA,
    SUBMIT_EDIT,
    SUBMIT_ADD,
    EDIT_DATA,
    DELE,
    LIST_ORDER
};
